import React from 'react';

export function NexusButton({ variant = 'primary', className = '', children, loading = false, ...props }) {
  const variantClass = variant === 'secondary'
    ? 'btn-secondary'
    : variant === 'danger'
      ? 'btn-primary danger-btn'
      : variant === 'page'
        ? 'page-btn'
        : 'btn-primary';
  return (
    <button className={`${variantClass} ${className}`.trim()} disabled={loading || props.disabled} {...props}>
      {loading ? 'Loading...' : children}
    </button>
  );
}
